export const GET_BOOKLETS_REQUEST = 'GET_BOOKLETS_REQUEST'
export const GET_BOOKLETS = 'GET_BOOKLETS'
export const GET_BOOKLETS_REQUEST_PENDING = 'GET_BOOKLETS_REQUEST_PENDING'
export const GET_BOOKLETS_REQUEST_SUCCESS = 'GET_BOOKLETS_REQUEST_SUCCESS'
export const GET_BOOKLETS_REQUEST_ERROR = 'GET_BOOKLETS_REQUEST_ERROR'

export const CREATE_BOOKLET_REQUEST = 'CREATE_BOOKLET_REQUEST'
export const CREATE_BOOKLET = 'CREATE_BOOKLET'
export const CREATE_BOOKLET_REQUEST_SUCCESS = 'CREATE_BOOKLET_REQUEST_SUCCESS'
export const CREATE_BOOKLET_REQUEST_ERROR = 'CREATE_BOOKLET_REQUEST_ERROR'

export const UPDATE_BOOKLET_REQUEST = 'UPDATE_BOOKLET_REQUEST'
export const UPDATE_BOOKLET = 'UPDATE_BOOKLET'
export const UPDATE_BOOKLET_REQUEST_ERROR = 'UPDATE_BOOKLET_REQUEST_ERROR'

export const GET_BOOKLET_REQUEST = 'GET_BOOKLET_REQUEST'
export const GET_BOOKLET = 'GET_BOOKLET'

export const GET_BOOKLET_TRANSACTIONS_REQUEST = 'GET_BOOKLET_TRANSACTIONS_REQUEST'
export const GET_BOOKLET_TRANSACTIONS = 'GET_BOOKLET_TRANSACTIONS'
export const GET_BOOKLET_TRANSACTIONS_REQUEST_PENDING = 'GET_BOOKLET_TRANSACTIONS_REQUEST_PENDING'
export const GET_BOOKLET_TRANSACTIONS_REQUEST_SUCCESS = 'GET_BOOKLET_TRANSACTIONS_REQUEST_SUCCESS'
export const GET_BOOKLET_TRANSACTIONS_REQUEST_ERROR = 'GET_BOOKLET_TRANSACTIONS_REQUEST_ERROR'

export const GET_BOOKLET_TRANSACTION_GROUPS_REQUEST = 'GET_BOOKLET_TRANSACTION_GROUPS_REQUEST'
export const GET_BOOKLET_TRANSACTION_GROUPS = 'GET_BOOKLET_TRANSACTION_GROUPS'
export const GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_PENDING = 'GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_PENDING'
export const GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_SUCCESS = 'GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_SUCCESS'
export const GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_ERROR = 'GET_BOOKLET_TRANSACTION_GROUPS_REQUEST_ERROR'
